export default __webpack_public_path__ + "static/media/2022_DeMalach_et_al_2022_Ecology.84c763d6.pdf";